import CompanyInfo from './CompanyInfo';
import './companyInfo.scss';
export default CompanyInfo;
